const getPlainTextFromHTML = (html: string) => {
    return html.replace(/<[^>]*>?/g, '');
}

export default getPlainTextFromHTML;const getPlainTextFromHTML = (html: string) => {
    return html.replace(/<[^>]*>?/g, '');
}

export default getPlainTextFromHTML;